import React, { useEffect, useState } from 'react'
import { Drawer, DrawerBody, DrawerContent, DrawerHeader, DrawerOverlay, Button, Box, Flex, Text, Select } from '@chakra-ui/react';
import { emptyAddDesignation, IAddDesignation, IDepartment, schema } from './model';
import { HrlenseInput } from '../../../../components/Input/Input';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { CustomTable, CustomToast } from '../../../../components';
import { useFetch } from '../../../../hooks/useFetch';
import { Column } from '../../../../components/CustomTable/customTable';


interface handleAddDesignationProps {
    isOpen: boolean;
    onClose: () => void;
    department: IDepartment | null;
}



export default function Designation({ isOpen, onClose, department }: handleAddDesignationProps) {
    const { addToast } = CustomToast();
    const { fetchApi } = useFetch(addToast);
    const [tableData, setTableData] = useState<any[]>([]);
    const [saving, setSaving] = useState(false);

    const { control, handleSubmit, formState: { errors }, reset } = useForm<IAddDesignation>({
        resolver: yupResolver(schema),
        defaultValues: emptyAddDesignation
    });

    const onSubmit = async (data: IAddDesignation) => {
        if (!department) return;
        setSaving(true);
        const payload = {
            Department_ID: department.id,
            designation_Name: data.designation,
        };
        const response = await fetchApi(`Hrlense_Department/Designation`, "POST", payload, null, "Designation added successfully");
        if (response) {
            reset(emptyAddDesignation);
            loadDesignations();
        }
        setSaving(false);
    }

    const loadDesignations = async () => {
        if (!department) return;
        const response = await fetchApi<any[]>(`Hrlense_Department/Designation`, "GET", null, `department_ID=${department.id}`);
        if (response) setTableData(response);
    }

    useEffect(() => {
        if (isOpen) {
            loadDesignations();
        }
    }, [isOpen]);

    return (
        <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="lg">
            <DrawerOverlay />
            <DrawerContent>
                <DrawerHeader borderBottomWidth="1px">
                    Add Designation to {department?.departmentName || 'Department'}
                </DrawerHeader>
                <DrawerBody>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Flex gap={4} align="flex-end">
                            <Box flex="1">
                                <HrlenseInput isRequired label='Designation' name='designation' control={control} errors={errors} />
                            </Box>
                        </Flex>
                        <Flex justify="flex-end" mt={4}>
                            <Button type="submit" isLoading={saving} bg="#006838" color="white" className="font-poppins text_sm text_medium" >
                                Add Designation
                            </Button>
                        </Flex>
                    </form>
                    {tableData.length > 0 && (
                        <Box mt={8}>
                            <Text mb={2} fontWeight="semibold">Existing Designation</Text>
                            <CustomTable value={tableData} emptyMessage='No Designation Found'>
                                <Column header="S. No" body={(_, idx) => idx + 1} />
                                <Column header="Designation" field="designation_Name" />

                            </CustomTable>
                        </Box>
                    )}
                </DrawerBody>
            </DrawerContent>
        </Drawer>
    )
}
